export const environment = {
  URL: 'https://back.dev.portal-personas.corecredit.co/api',
  USER: '',
  PASS: '',

};
